export async function createVendor(payload) {
    try {
      const response = await fetch("https://hs2api.razamit.pl/vendors", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Błąd API (${response.status}): ${errorText}`);
      }
  
      const data = await response.json();
      return data;
    } catch (err) {
      console.error("❌ Błąd tworzenia użytkownika:", err);
      throw err;
    }
  }
  
  export async function updateVendor(id, patch) {
    try {
    
      const res = await fetch(`https://hs2api.razamit.pl/vendors?id=${id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(patch),
      });
  
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || 'Błąd podczas aktualizacji użytkownika');
      }
  
      return await res.json(); // { success: true, message: '...' }
    } catch (error) {
      console.error('updateUser error:', error);
      throw error;
    }
  }
  